/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const getChangeRequestStatusByIdIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const GetChangeRequestStatusById = zod.object({
  "id": zod.union([zod.number(),zod.string().regex(getChangeRequestStatusByIdIdRegExpTwo)]).optional()
});

export type GetChangeRequestStatusById = zod.input<typeof GetChangeRequestStatusById>;
export type GetChangeRequestStatusByIdOutput = zod.output<typeof GetChangeRequestStatusById>;
